import Footer from "components/organisms/Footer/GlobalFooter";
import MobileFooter from "components/organisms/Footer/MobileGlobalFooter";
import Header from "components/organisms/Header/NotificationHeader";
import Media from "react-media";
import Body from "views/DesktopViews/NotificationPage";

const Notification = () => {
  return (
    <>
      <Header />
      <Body />

      <Media query="(max-width: 599px)">
        {matches=>
            matches ? (
              <MobileFooter />
            ) : (
              <Footer />
            )
        }
      </Media>
    </>
  );
};

export default Notification;
